import { FC } from 'react';
import { TransportSelectionContext } from './TransportSelectionContext';
import { AuthenticationContext } from './AuthenticationContext';

type Props = {
	context: string;
};

export const FormContext: FC<Props> = ({ context }) => {
	if (context === 'authentication') {
		return <AuthenticationContext />;
	}

	if (context === 'transport_selection') {
		return <TransportSelectionContext />;
	}

	return <></>;
};
